module.exports = __webpack_public_path__ + "static/media/logo.b9f8cdbf.png";